import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// import axios from 'axios'

export default new Vuex.Store({
  state: {
    photos: [],
  },
  getters: {

    photos(state) {
      return state.photos
    }

  },
  mutations: {

    photos(state, payload) {
      state.photos = payload
    },
  },

  actions: {

    // TODO 動的にインスタ投稿
    // getPhotos(context) {
    //   axios.get('/api/v1/photos')
    //     .then(response => {
    //       context.commit('photos', response.data)
    //     })
    //     // .catch(error => {
    //       // console.error(error)
    //     // })
    // },

  },
})
